import React, { useEffect, useState } from "react";
import { Table, Image, Modal, Select, Button, message } from "antd";
import { useCustomerList } from "../../../api/customer";
import { useAddVCEOrder, useGetVCEByOrderId } from "../../../api/order";
import TableAction from "../../TableAction";
import { useGetUsersListByRole } from "../../../api/profile";
import {
  useAssignOrderToAgroDealer,
  useGetAgroDealersByOrderId,
  useGetAgroDealersList,
  useRemoveAgroDealerFromOrder,
} from "../../../api/agro_dealer";

type vceTableProps = {
  orderId: string;
};

const AgroDealerTable: React.FC<vceTableProps> = ({ orderId }) => {
  const {
    data: a_dealrs,
    isLoading,
    refetch: fetchAgroDealers,
  } = useGetAgroDealersByOrderId(orderId);
  const [profiles, setProfiles] = useState<any>();
  const [adId, setAdId] = useState<string | undefined>();
  const [selectedId, setSelectedId] = useState<number | undefined>();

  const { data: all_agro_dealers } = useGetAgroDealersList();
  const { mutateAsync: assignAgroDealer, isPending } =
    useAssignOrderToAgroDealer();
  const { mutateAsync: removeAgroDealer, isPending: removing } =
    useRemoveAgroDealerFromOrder();

  const [searchText, setSearchText] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const hideRemoveModal = () => {
    setRemoveOpen(false);
  };

  useEffect(() => {
    if (a_dealrs && a_dealrs.data && a_dealrs.data.data.length > 0) {
      setProfiles(a_dealrs.data.data);
    }
  }, [a_dealrs]);

  const onSubmit = async () => {
    if (adId && orderId) {
      try {
        const result = await assignAgroDealer({
          orderId: Number(orderId),
          orgId: Number(adId),
        });

        if (result.status === 200) {
          message.success("Agro-dealer assigned successfully.");
        } else {
          message.error("Operation failed.");
        }
      } catch (err: any) {
        message.error("Operation failed.");
      } finally {
        fetchAgroDealers();
        setOpen(false);
      }
    }
  };

  const onRemove = async () => {
    if (selectedId) {
      try {
        const result = await removeAgroDealer(selectedId);

        if (result.status === 200) {
          message.success("Agro-dealer assigned successfully.");
        } else {
          message.error("Operation failed.");
        }
      } catch (err: any) {
        message.error("Operation failed.");
      } finally {
        fetchAgroDealers();
        setRemoveOpen(false);
      }
    }
  };

  const vceColumn = [
    {
      title: "No.",
      width: 20,
      render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
    },
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (id: number) => {
        return (
          <Button
            onClick={() => {
              setSelectedId(id);
              setRemoveOpen(true);
            }}
          >
            Remove
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        open={removeOpen}
        title={<div className="text-black">Remove</div>}
        onOk={onRemove}
        onCancel={hideRemoveModal}
        okButtonProps={{
          disabled: removing,
          loading: removing,
        }}
      >
        <div className="text-black">
          Are you sure you want to remove the selected agro-dealer from this
          order?
        </div>
      </Modal>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontSize: 27.43,
              color: "black",
            }}
          >
            Select agro dealer
          </div>
        }
        open={open}
        centered
        onOk={onSubmit}
        okButtonProps={{
          disabled: adId === undefined || isPending,
          loading: isPending,
        }}
        onCancel={hideModal}
        closable
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Select
            value={adId}
            placeholder="Select agro dealer"
            style={{ width: "100%" }}
            onChange={(val: any) => setAdId(val)}
            options={all_agro_dealers?.data?.data?.map((ad: any) => {
              return { label: ad.name, value: ad.id };
            })}
          />
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} onCreateNew={handleCreate} />
      </div>
      <Table
        dataSource={profiles || []}
        columns={vceColumn}
        loading={isLoading}
      />
    </>
  );
};

export default AgroDealerTable;
